// extracted by mini-css-extract-plugin
export default {"applicationsContainer":"ApplicationsList_applicationsContainer__tVOu4"};